import { Navigate, Outlet } from 'react-router-dom';

import { pagePathSegments } from '~constants';
import { useSession } from '~hooks';
import { GeneralLoaderWrapper } from '~layouts';

const PublicRoute = () => {
	const session = useSession();

	// In mock mode, skip login and go straight to Home
	if (session.isMock) {
		return <Navigate to={pagePathSegments.Home} replace />;
	}

	if (session.isLoading) {
		// Sometimes the UI has a proper loading state, in that case we can keep that state
		// and not flash a full screen loader.
		if (session.bypassLoader) {
			return <Outlet />;
		} else {
			return <GeneralLoaderWrapper />;
		}
	} else if (session.hasValidSession) {
		return <Navigate to={pagePathSegments.Home} replace />;
	}

	return <Outlet />;
};

export default PublicRoute;
